import { IGetColetaPrecoByIdUseCase } from "../../../presentation/useCases/read/get_coleta_preco_by_id_use_case";
import { ColetaPreco } from "../../models/coleta_preco";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetColetaPrecoByIdUseCase
 */

export class GetColetaPrecoByIdUseCase implements IGetColetaPrecoByIdUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getColetaPrecoById(
    idColetaPreco: number | undefined,
  ): Promise<ColetaPreco> {
    if (idColetaPreco === undefined) throw new Error('Id de coleta de preço invalido!');

    const response = await this.repository.getColetaPrecoById(
      idColetaPreco,
    );

    if (response === null) throw new Error('Falha ao buscar coleta de preço!');

    return response;
  }
}
